export default __webpack_public_path__ + "static/media/ss-standard.ff8f23da.ttf";